import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { countryToAlpha2 } from 'country-to-iso';
import './DinnerCard.css';
import PreviewProfileModal from './PreviewProfileModal';
import IcebreakerModal from './IcebreakerModal';
import whatsappIcon from '../assets/whatsapp.png';

export default function ProfileDinnerCard({
  hostProfile,
  dinner,
  actionsType = 'pending',
  onReminder,
  hideKosherLevel = false,
  isHostView = false
}) {
  const [showPreview, setShowPreview] = React.useState(false);
  const [icebreakerOpen, setIcebreakerOpen] = React.useState(false);
  if (!hostProfile || !dinner) return null;

  // עיבוד תאריך
  let dateStr = '';
  if (dinner.dinnerDetails?.availableDates && dinner.dinnerDetails.availableDates.length > 0) {
    const dateObj = new Date(dinner.dinnerDetails.availableDates[0]);
    dateStr = dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  // עיבוד מיקום
  const location = [dinner.address?.city, dinner.address?.country].filter(Boolean).join(', ');
  
  // פונקציה להמרת שם מדינה לקוד מדינה (כמו במסך הבית)
  const getCountryCodeSafe = (country) => {
    if (!country) return '';
    
    // מיפוי ידני לשמות מדינות בעייתיים
    const countryNameMap = {
      'United States of America': 'US',
      'USA': 'US',
      'United Kingdom': 'GB',
      'UK': 'GB',
      'Czechia': 'CZ',
      'Czech Republic': 'CZ'
    };
    
    const normalized = country.trim();
    if (countryNameMap[normalized]) return countryNameMap[normalized];
    
    const code = countryToAlpha2(normalized);
    return code || '';
  };
  
  const countryCode = getCountryCodeSafe(dinner.address?.country);

  // עיבוד פרטי הארוחה
  const mealStyles = Array.isArray(dinner.dinnerDetails?.mealStyle) ? dinner.dinnerDetails.mealStyle : [];

  return (
    <div className="dinner-card-v2">
      {/* פס סטטוס למעלה */}
      {actionsType === 'accepted' ? (
        <div className="dinner-card-status-pill" style={{ background: '#d2f1ec', color: '#22685b' }}>Accepted</div>
      ) : (
        <div className="dinner-card-status-pill">Request Sent</div>
      )}
      <img src={hostProfile.profileImg || '/placeholder-profile.png'} alt={hostProfile.name} className="dinner-card-v2-avatar" />
      <div className="dinner-card-v2-content">
        <div className="dinner-card-v2-title-row">
          <div>
            <div className="dinner-card-v2-title">
              <span
                style={{ cursor: 'pointer', color: '#15316b', fontWeight: 700 }}
                onClick={() => setShowPreview(true)}
              >
                {hostProfile.name}
              </span>
            </div>
            <div className="dinner-card-v2-location">
              {location}
              {dinner.address?.country && (
                <ReactCountryFlag countryCode={countryCode} svg style={{ fontSize: '1em', marginLeft: 6, verticalAlign: 'middle' }} />
              )}
            </div>
          </div>
        </div>
        <div className="dinner-card-v2-we-speak-row">
          <span className="dinner-card-v2-we-speak-label">We speak:</span> <span className="dinner-card-v2-we-speak-value">{hostProfile.languages}</span>
        </div>
        {/* הצג meal style/סוג ארוחה רק אם לא במצב accepted+im a host או past */}
        {!(actionsType === 'accepted' && isHostView) && actionsType !== 'past' && !hideKosherLevel && dinner.dinnerDetails?.kosherType && (
          <div className="dinner-card-v2-kosher-row" style={{ marginTop: 0, marginBottom: 6, textAlign: 'left', paddingLeft: 0 }}>
            <span className="dinner-card-v2-we-speak-label">Kosher level:</span> <span className="dinner-card-v2-we-speak-value">{dinner.dinnerDetails.kosherType}</span>
          </div>
        )}
        {!(actionsType === 'accepted' && isHostView) && actionsType !== 'past' && dinner.dinnerDetails?.time && (
          <div className="dinner-card-v2-time-row" style={{ marginTop: 0, marginBottom: 6, textAlign: 'left', paddingLeft: 0 }}>
            <span className="dinner-card-v2-we-speak-label">Dinner Time:</span> <span className="dinner-card-v2-we-speak-value">{dinner.dinnerDetails.time}</span>
          </div>
        )}
        {!(actionsType === 'accepted' && isHostView) && actionsType !== 'past' && (
          <div className="dinner-card-v2-details-row">
            <ul>
              {mealStyles.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
        )}

        <div className="dinner-card-v2-date-row">
          <span className="dinner-card-v2-date-pill">
            <b>Date:</b> {dateStr}
          </span>
        </div>
        <div className="dinner-card-v2-actions-row" style={{ gap: 16, width: '100%', justifyContent: 'flex-end', flexWrap: 'nowrap', position: 'relative' }}>
          {actionsType === 'accepted' ? (
            <>
              <button
                style={{
                  background: '#b3d8ee',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 28,
                  padding: '10px 28px',
                  fontWeight: 600,
                  fontSize: '1.13em',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                  fontFamily: 'Inter, sans-serif',
                  transition: 'background 0.2s',
                  cursor: 'pointer',
                  minWidth: 180,
                  maxWidth: 320,
                  width: 'auto',
                  position: 'absolute',
                  left: '-102px',
                  top: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: 1,
                  whiteSpace: 'nowrap',
                  gap: 10,
                  textAlign: 'center',
                  zIndex: 1
                }}
                onClick={() => setIcebreakerOpen(true)}
              >
                <span role="img" aria-label="ice-cube" style={{ fontSize: 22, marginRight: 8, verticalAlign: 'middle' }}>🧊</span>
                Generate Ice Breakers
              </button>
              <a
                className="dinner-card-v2-reminder-btn"
                style={{
                  background: (hostProfile.whatsappNumber || hostProfile.phone) ? '#25D366' : '#bdbdbd',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  textDecoration: 'none',
                  justifyContent: 'center',
                  minWidth: 120,
                  width: '34%',
                  border: 'none',
                  borderRadius: 28,
                  padding: '10px 28px',
                  fontWeight: 600,
                  fontSize: '1.13em',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                  fontFamily: 'Inter, sans-serif',
                  transition: 'background 0.2s',
                  cursor: (hostProfile.whatsappNumber || hostProfile.phone) ? 'pointer' : 'not-allowed',
                  opacity: (hostProfile.whatsappNumber || hostProfile.phone) ? 1 : 0.5,
                  marginLeft: 'auto',
                  marginRight: 0,
                  order: 1,
                }}
                href={(hostProfile.whatsappNumber || hostProfile.phone) ? `https://wa.me/${(hostProfile.whatsappNumber || hostProfile.phone).replace(/[^0-9]/g, '')}` : undefined}
                target="_blank"
                rel="noopener noreferrer"
                tabIndex={0}
                aria-disabled={!(hostProfile.whatsappNumber || hostProfile.phone)}
                onClick={e => {
                  if (!(hostProfile.whatsappNumber || hostProfile.phone)) e.preventDefault();
                }}
              >
                <img src={whatsappIcon} alt="WhatsApp" style={{ width: 28, height: 28, marginRight: 4, verticalAlign: 'middle' }} />
                contact
              </a>
            </>
          ) : (
            <button className="dinner-card-v2-reminder-btn" onClick={onReminder}>
              <FontAwesomeIcon icon={faBell} style={{ marginRight: 8, fontSize: 18, verticalAlign: 'middle' }} />
              Send a reminder
            </button>
          )}
        </div>
      </div>
      <PreviewProfileModal
        open={showPreview}
        onClose={() => setShowPreview(false)}
        profile={{
          uid: hostProfile.uid || hostProfile.id,
          avatar: hostProfile.profileImg,
          name: hostProfile.name,
          city: hostProfile.location?.city || dinner.address?.city,
          country: hostProfile.location?.country || dinner.address?.country,
          code: dinner.address?.countryCode || '',
          bio: hostProfile.about,
          languages: hostProfile.languages,
          interests: hostProfile.interests,
          gallery: hostProfile.gallery,
          funFact: dinner.shabbotAnswers?.funFact || hostProfile.shabbotAnswers?.funFact,
          shabbotAnswers: dinner.shabbotAnswers || hostProfile.shabbotAnswers
        }}
      />
      <IcebreakerModal open={icebreakerOpen} onClose={() => setIcebreakerOpen(false)} dinnerId={dinner.id} />
    </div>
  );
} 